<script>
  import {onMount,onDestroy,tick} from "svelte"
  export let pause = false
  let node, slide_idx, slides = [], tag, running = false, timeout, inEditArea,observer,updated=false, pullright

  onMount(()=>{
    tag = node.getRootNode().host
    // pullright = tag.classList.contains('panel-right')
    console.log(pullright)
    getSlides()
    inEditArea = tag.closest('[contenteditable]') != null
    running = !inEditArea 
    if(!pause) start()
    if(inEditArea){
      observer = new MutationObserver(hasChanged)
      observer.observe(tag, { attributes: false, childList: true, subtree: false });
    }
  })

  onDestroy(()=>{
    clearTimeout(timeout)
    if(observer) observer.disconnect()
  })

  function getSlides(){
    slides = Array.from(tag.children)
    slide_idx = slides.findIndex( node => node.classList.contains("active"))
  }

  function hasChanged(mutationsList, observer) {
    for(const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        getSlides()
      }
    }
  }

  function next(){
    slide_idx = ( slide_idx+1 < slides.length ? slide_idx+=1 : 0 )
    start()
  }

  function prev(){
    slide_idx = ( slide_idx > 0 ? slide_idx-=1 : slides.length-1 )
    start()
  }

  function goto(idx){
    slide_idx = idx
    start()
  }

  async function updateSlideFromIndex(){
    if(slide_idx == null || !tag) return
    tag.querySelector(".active").classList.remove("active");
    slides[slide_idx].classList.add("active")
    updated = false 
    requestAnimationFrame(() => {
      updated = true
    });
  }

  function start(){
    clearTimeout(timeout)
    if(running){
      running = false
      setTimeout(()=> running = true) // hack to force animation to restart
    }
    timeout = setTimeout(()=>{
      if(running && !pause) next()
      start()
    },4000)
  }

  // prevents animation when not visible
  window.addEventListener('visibilitychange',()=>{
    running = !document.hidden
  });

  $ : updateSlideFromIndex(slide_idx)

</script>

<div class="duo-panel" part="panel" bind:this={node}>
  {#if running && !pause}<div class="timer" part="timer"></div>{/if}
  <div class="wrapper" part={"wrapper"+(updated ? " updated" : "")} >
    <slot />
  </div>
  <div class="controls">
    <button class="next" part="next" disabled={inEditArea} on:click={next}></button>
    <button class="prev" part="prev" disabled={inEditArea} on:click={prev}></button>
    <div class={"pager"+(pullright ? " pager-right" : "")} part="pager">
      {#each slides as slide,idx}
        <button part={"pagerbutton"+ (idx == slide_idx ? " active" : "")} on:click={()=> goto(idx)} disabled={inEditArea} class:active={idx == slide_idx}></button>
      {/each}
    </div>
  </div>
</div>


<style>

  :global(.duo-panel ::slotted(.panelcol)){ /* direct descendant of this tag */
    display: block;
    position:absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    opacity: 0;
    transition: 0.5s transform,  0.5s opacity;
    transition-delay: 0.5s;
  }
  :global(.duo-panel ::slotted(.panelcol.active)){
    opacity: 1;
    position: relative;
    margin-top:0;
    z-index: 1;
    transition-delay: 0s;
  }

  .timer{
    position:absolute;
    bottom:0;
    left:0;
    height:5px;
    width:100%;
    background:white;
    opacity:0.3;
    transform-origin: top left;
    animation:4s linear infinite fill;
    z-index:10;
  }

  @keyframes fill{
    0%{
      transform:scaleX(0);
    }
    100%{
      transform:scaleX(1);
    }
  }

  .duo-panel{
    position: relative;
    display:block;
  }
  .controls{
    z-index:10;
  }

  .controls .next,
  .controls .prev{
    all:unset;
    position: absolute;
    display: block;
    top: 0;
    bottom: 0;
    right: 0;
    text-shadow: 0 0 5px rgba(0,0,0,0.5);
    transition: 0.5s all;
    color: rgba(255,255,255,0.8);
    background: rgba(0,0,0,0);
    padding: 18% 20px;
    font-size: 30px;
    line-height: 100%;
    z-index: 2;
    cursor:pointer;
    display:none;
  }
  .controls .next:hover,
  .controls .prev:hover{
    background: rgba(0,0,0,0.5);
    color: #fff;
  }
  .controls .next:before,
  .controls .prev:before{
    content:'';
    position: absolute;
    top: calc(50% - 20px);
    left: 10px;
    height:30px;
    width:30px;
    background-image:url('data:image/svg+xml;utf8,<svg width="100%" height="100%" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><path fill="white" d="m66.156 50l-2.2188-2.5938-24-28-6.0938 5.1875 21.781 25.406-21.781 25.406 6.0938 5.1875 24-28z"/></svg>')

  }
  .controls .prev{
    right: auto;
    left: 0;
    transform:scaleX(-1)
  }

  .controls .pager{
    position: absolute;
    z-index: 2;
    bottom: 20px;
    left: 0;
    right: 0;
    height: 20px;
    display: flex;
    justify-content: center;
    width:50%;
  }
  .controls .pager-right{
    margin-left:50%;
  }
  .controls .pager button{
    all:unset;
    width: 12px;
    height: 12px;
    background: rgba(255,255,255,0);
    box-shadow: 0 0 5px rgba(0,0,0,0.5);
    border: 1px solid #fff;
    display: inline-block;
    margin: 5px;
    cursor:pointer;
    border-radius: 50%;
  }
  .controls button.active{
    background: #fff;
  }

  .controls button[disabled]{
    cursor:not-allowed;
  }

  @media (max-width:991px){
    .controls .pager{
      width:100%;
      margin-left:auto;
    }
  }


</style>